import _ from 'underscore';
import contactTemplate from 'text!./templates/contact-template.html';

export default ['$modal', 'ContactUtils', '$filter', function ($modal, ContactUtilsSvc, $filter) {
    var modalController = ['$scope', '$modalInstance', 'contact', function ($scope, $modalInstance, contact) {
        $scope.$filter = $filter;
        $scope.contact = contact;
        $scope.displayName = ContactUtilsSvc.getDisplayName($scope.contact, $filter);
        $scope.fullAddress = ContactUtilsSvc.getFullAddress($scope.contact.primaryAddress);
        $scope.isA = function (contactType) {
            return ContactUtilsSvc.isInstanceOf($scope.contact, contactType);
        };
    }];

    var controller = ['$scope', function controller($scope) {
        $scope.open = function () {
            $modal.open({
                template: contactTemplate,
                controller: modalController,
                resolve: {
                    contact: function contact() {
                        return $scope.contact;
                    }
                }
            });
        };

        _.extend($scope, ContactUtilsSvc);
    }];

    return {
        restrict: 'A',
        replace: true,
        template: '<a data-ng-click="open()">{{getDisplayName(contact, $filter)}}</a>',
        link: function link(scope, element) {
            if (!angular.isDefined(scope.contact)) {
                element.replaceWith('<span>Private</span>');
            }
        },
        controller: controller,
        scope: {
            contact: '=gwPlContactLink'
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/contacts/ContactLinkDirective.js
// module id = 1026
// module chunks = 0